/**
 *
 * Asynchronously loads the component for ChatbotQuiz
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/graphql/ChatbotQuizSubmissionPart2/loadable.js